export default [
  {
    path: '/locationSettings',
    component: () => import('./LocationSettings'),
    children: [
      {
        path: 'thriveOnline',
        component: () => import('./LimitedManageOnlineForm'),
        name: 'limitedManageOnlineForm'
      },
      {
        path: 'orderTypes',
        component: () => import('./order-types/OrderTypes.vue'),
        name: 'orderTypes'
      },
      {
        path: 'onlineDesign',
        component: () => import('./online-design/OnlineDesign.vue'),
        name: 'onlineDesign'
      },
      {
        path: 'posDesign',
        component: () => import('./pos-design/PosDesign.vue'),
        name: 'posDesign'
      },
      {
        path: 'hours',
        component: () => import('./hours/HoursForm.vue'),
        name: 'hoursForm'
      },
      {
        path: 'deliverySettings',
        component: () => import('./delivery-settings/DeliverySettingsForm.vue'),
        name: 'deliverySettingsForm'
      },
      {
        path: 'tableAndBar',
        component: () => import('./table-and-bar/TableAndBar.vue'),
        name: 'tableAndBar'
      },
      {
        path: 'marketing',
        component: () => import('./marketing/Marketing.vue'),
        name: 'marketing'
      },
      {
        path: 'creditAndGift',
        component: () => import('./credit-and-gift/CreditAndGift.vue'),
        name: 'creditAndGift'
      },
      {
        path: 'payments',
        component: () => import('./payments/Payments.vue'),
        name: 'payments'
      },
      {
        path: 'stations',
        component: () => import('./stations/Stations'),
        name: 'stations'
      },
      {
        path: 'printers',
        component: () => import('./printers/Printers'),
        name: 'printers'
      },
      {
        path: 'printerOptions',
        component: () => import('./printer-options/PrinterOptions'),
        name: 'printerOptions'
      },
      {
        path: 'cashDrawers',
        component: () => import('./cash-drawers/CashDrawers'),
        name: 'cashDrawers'
      },
      {
        path: 'mobileApp',
        component: () => import('./mobile-app/MobileApp'),
        name: 'mobileApp'
      }
    ]
  }
]
